import React, { useState, useEffect, useCallback } from 'react';
import Cookies from 'universal-cookie';

import { Trans, useTranslation } from 'next-i18next';
import styles from './../styles/CookieNotice.module.scss';
import {getPrivacyPolicyLink} from "../utils";

const cookies = new Cookies();

const CookieNotice: React.FC = () => {
  const [cookieState, setCookieState] = useState(true);
  const { t, i18n } = useTranslation('common');

  const cookieName = 'cookie_notice_accepted';

  useEffect(() => {
    const cookie = cookies.get(cookieName);
    setCookieState(typeof cookie !== 'undefined' ? cookie : false);
  }, []);

  const acceptCookie = () => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 31);

    cookies.set(cookieName, true, { expires });
    setCookieState(true);
  };

  return (
    <div>
      {!cookieState && (
        <div key="cookie" className={styles.cookieNoticeContainer}>
          <div className={styles.cookieNoticeWrapper}>
            <div className={styles.innerWrapper}>
              <p className={styles.infoText}>
                <Trans
                  ns="common"
                  i18nKey="cookies-info"
                  components={{
                    privacyPolicy: <a className={styles.privacyPolicyLink} href={getPrivacyPolicyLink(i18n.language)} />
                  }}
                />
              </p>
              <button
                className={styles.cookieBtn}
                type="button"
                onClick={acceptCookie}
              >
                {t('cookies-accept')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieNotice;
